// extracted by mini-css-extract-plugin
export default {"list":"uPCk_","no-collections":"DTU46","collections":"JsTj0"};